import { rgObjectToDto } from "./index195.js";
import { strToU8, zlib } from "fflate";
function CompressRgObjectAsync(obj) {
	return new Promise((resolve, reject) => {
		zlib(strToU8(JSON.stringify(rgObjectToDto(obj))), { level: 9 }, (err, data) => {
			if (err) return reject(err);
			resolve(data);
		});
	});
}
export { CompressRgObjectAsync };

//# sourceMappingURL=index196.js.map